import { createSlice, PayloadAction } from '@reduxjs/toolkit';

// FIX: Added 'export' so other files can import this type
export interface Product {
  id: string;
  name: string;
  price: string;
  /** Primary product image (preferred over legacy `image_urls`). */
  primary_image_url: string;
  /** Legacy multi-image support (kept for backward compatibility). */
  image_urls?: string[];
  colors?: string[];
  sizes?: string[];
  type: string;
  color: string;
  regular_price: string;
  url: string;
  variant_id: string;
  size: string;
  product_image_link?: string;
  hex_code?: string;
  /** Map of size -> Shopify variant ID; used at checkout for the selected size */
  variant_ids?: Record<string, string>;
}

interface ProfileState {
  name: string;
  email: string;
  selfieUrl: string;
  // ⭐ NEW: base64 selfie for NanoBanana / final look
  selfieBase64?: string;

  profession: string;
  age?: string; // Optional field
  mobile: string;

  hairColor: string;
  skinTone: string;
  eyeColor: string;
  faceType: string;

  recommended_products: Product[]; // Now correctly uses the exported Product type

  // ⭐ NEW: simple string fields for height/weight/bodyType (used by FinalLook.tsx)
  height?: string;    // e.g. "5'9"
  weight?: string;    // e.g. "72"
  bodyType?: string;  // e.g. "fit", "average", etc.

  bodyAnalysis: {
    height: number;
    weight: number;
    type: string;
  };
}

export const profileInitialState: ProfileState = {
  name: '',
  email: '',
  selfieUrl: '',
  // ⭐ default empty string for base64 selfie
  selfieBase64: '',

  profession: '',
  mobile: '',
  hairColor: '',
  skinTone: '',
  eyeColor: '',
  faceType: '',
  recommended_products: [],

  // ⭐ default empty strings for the simple fields
  height: '',
  weight: '',
  bodyType: '',

  bodyAnalysis: { height: 0, weight: 0, type: '' },
};

const profileSlice = createSlice({
  name: 'profile',
  initialState: profileInitialState,
  reducers: {
    setProfile: (state, action: PayloadAction<Partial<ProfileState>>) => {
      // shallow merge – keeps existing values unless overwritten
      Object.assign(state, action.payload);
    },
    setAnalysis: (state, action: PayloadAction<any>) => {
      state.hairColor = action.payload.hair_color || 'unknown';
      state.skinTone = action.payload.skin_tone || 'unknown';
      state.eyeColor = action.payload.eye_color || 'unknown';
      state.faceType = action.payload.face_type || 'unknown';
      state.recommended_products = action.payload.recommended_products || [];
      if (action.payload.bodyAnalysis) {
        state.bodyAnalysis = action.payload.bodyAnalysis;
      }
    },
  },
});

export const { setProfile, setAnalysis } = profileSlice.actions;
export default profileSlice.reducer;
